import actions from '@/store/companies/actions';

const companiesModule = {
  state: () => ({
    companies: [],
    companiesTotal: 0,
    isCompaniesLoaded: true,
    currentCompany: null,
    isCurrentCompanyLoaded: false,
    currentCompanyColors: [],
  }),
  getters: {
    sortedCompanies(state) {
      return state.companies || [];
    },
  },
  mutations: {
    GET_COMPANIES_REQUEST(state) {
      state.isCompaniesLoaded = false;
    },
    GET_COMPANIES_SUCCESS(state, { data, total }) {
      state.companies = data;
      state.companiesTotal = Number(total) || 0;
      state.isCompaniesLoaded = true;
    },
    GET_COMPANIES_ERROR(state) {
      state.isCompaniesLoaded = true;
    },
    GET_COMPANY_REQUEST(state) {
      state.isCurrentCompanyLoaded = false;
    },
    GET_COMPANY_SUCCESS(state, company) {
      state.currentCompany = company;
      state.isCurrentCompanyLoaded = true;
    },
    GET_COMPANY_ERROR(state) {
      state.isCurrentCompanyLoaded = true;
    },
    GET_COMPANY_COLORS_SUCCESS(state, companyColors) {
      state.currentCompanyColors = companyColors;
    },
  },
  actions,
  namespaced: true,
};

export default companiesModule;
